module.exports = __webpack_public_path__ + "images/emoji/bride_with_veil.1d06f9f31466d5c4f2cd.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/bride_with_veil.png
// module id = 0KBb
// module chunks = 14